import React from 'react';

class MyChartProxyButton extends React.Component {
    render() {
        return (
            <div>
            &nbsp;
            </div>);
                    }
                
                }
                
export default MyChartProxyButton;